import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import useCanSeeApprovalRequest from 'modules/contracts/hooks/useCanSeeApprovalRequest'
import type ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import { FLOWS } from '../FlowSelectorModal/constants'

interface Props {
  onCloseModal: () => void
  contractVersionRequest: ContractVersionRequest
  employee: Employee
}

const PendingApprovalModal = ({ onCloseModal, contractVersionRequest, employee }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const onSubmit = () => {
    track(trackingEvents.employee.contracts.goToContractRequest, {
      source: 'modal',
      approval_status: contractVersionRequest.attributes.status,
      request_type: FLOWS.promotion,
      request_date: contractVersionRequest.attributes.approval_request_created_at,
      request_reason: contractVersionRequest.attributes.request_details,
    })
    navigate(
      navigation.employees.id.contractVersions.approval_request.fullPath({
        contractVersionId: contractVersionRequest.id,
        id: employee.id,
      })
    )
  }
  const requesterId = contractVersionRequest.attributes.approval_author_id || ''
  const requester = users.find({ id: requesterId })
  const requesterName = requester?.fullName() || ''

  const canPromote = policyAuthorizations.for('contracts.promote', employee)
  const canSeeAprovalRequest = useCanSeeApprovalRequest({
    contractVersionRequest,
    canPromote,
  })

  return (
    <Modal
      title={i18n.t('contract_versions.modals.pending_request.title', {
        requesterName: requesterName,
      })}
      illustration="alert"
      onSubmit={onSubmit}
      onClose={onCloseModal}
      description={i18n.t('contract_versions.modals.pending_request.description')}
      footer={
        <>
          <Button disabled={false} onClick={onCloseModal} type="secondary">
            {canSeeAprovalRequest
              ? i18n.t('common.cancel')
              : i18n.t('contract_versions.modals.pending_request.back_button')}
          </Button>
          {canSeeAprovalRequest && (
            <Button submit>
              {i18n.t('contract_versions.modals.pending_request.review_request')}
            </Button>
          )}
        </>
      }
    ></Modal>
  )
}

export default observer(PendingApprovalModal)
